import SingleToolFooter from '@quicktools/shared-components/components/common/SingleToolFooter/SingleToolFooter';
import { ImageWithTextSection } from '@quicktools/shared-components/components/landingPages/ImageWithTextSection';
import { SYMBOLS_TOOL, ToolCategory } from '@quicktools/shared-components/data/tools';
import { useTranslation } from 'react-i18next';
import { memo } from 'react';
import { SingleToolSimilar } from '@quicktools/shared-components';

import analytics from '../../services/analytics';
import { SIMILAR_TOOLS } from '../../configs';

import { ICategoryContentProps } from './types';

function CategoryContent({ imgs, category }: ICategoryContentProps) {
  const { t } = useTranslation();

  return (
    <>
      {imgs.map(({ url, width }, i) => {
        const baseKey = `categories.${category}.sections.${i}`;
        const title = t(`${baseKey}.title`);
        const description = t(`${baseKey}.description`);
        const imageRight = !(i % 2);

        return (
          <ImageWithTextSection
            key={url}
            imgSrc={url}
            imgAlt=""
            imageWidth={width}
            title={title}
            description={description}
            imageRight={imageRight}
          />
        );
      })}

      <SingleToolSimilar
        current={SYMBOLS_TOOL}
        analytics={analytics}
        similar={SIMILAR_TOOLS}
        paragraph={t('landing.similarTools.paragraph')}
        category={ToolCategory.Text}
      />
      <SingleToolFooter analytics={analytics} />
    </>
  );
}

export default memo(CategoryContent);
